import { render, staticRenderFns } from "./envio-revision-partidas.vue?vue&type=template&id=2cd76208&scoped=true&"
import script from "./envio-revision-partidas.vue?vue&type=script&lang=js&"
export * from "./envio-revision-partidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd76208",
  null
  
)

export default component.exports